import {
  TextBlock,
  CallToActionCampaign,
  CallToAction,
  FeedbackToolBlock,
  NLdoetCallToActionBlock,
  AppeltjesCTA,
} from '../implementations';

const mappers = {
  text: TextBlock,
  call_to_action: CallToAction,
  call_to_action_campaign: CallToActionCampaign,
  feedback: FeedbackToolBlock,
  call_to_action_nldoet: NLdoetCallToActionBlock,
  avo_cta: AppeltjesCTA,
};

export default mappers;

